import { Badge } from "@thilke/ui/components/badge";
import { Button } from "@thilke/ui/components/button";
import {
  ActionBar,
  ActionBarGroup,
  ActionBarItem,
  ActionBarSelection,
  ActionBarSeparator,
} from "@thilke/ui/components/ui/action-bar";
import {
  AngleSlider,
  AngleSliderRange,
  AngleSliderThumb,
  AngleSliderTrack,
  AngleSliderValue,
} from "@thilke/ui/components/ui/angle-slider";
import { AvatarGroup } from "@thilke/ui/components/ui/avatar-group";
import { BadgeOverflow } from "@thilke/ui/components/ui/badge-overflow";
import {
  Banner,
  BannerContent,
  BannerDescription,
  BannerIcon,
  BannerTitle,
} from "@thilke/ui/components/ui/banner";
import {
  CheckboxGroup,
  CheckboxGroupDescription,
  CheckboxGroupItem,
  CheckboxGroupLabel,
  CheckboxGroupList,
} from "@thilke/ui/components/ui/checkbox-group";
import { CircularProgressCombined } from "@thilke/ui/components/ui/circular-progress";
import {
  ColorPicker,
  ColorPickerTrigger,
} from "@thilke/ui/components/ui/color-picker";
import { ColorSwatch } from "@thilke/ui/components/ui/color-swatch";
import {
  Combobox,
  ComboboxAnchor,
  ComboboxContent,
  ComboboxInput,
  ComboboxItem,
  ComboboxTrigger,
} from "@thilke/ui/components/ui/combobox";
import {
  CompareSlider,
  CompareSliderAfter,
  CompareSliderBefore,
  CompareSliderHandle,
} from "@thilke/ui/components/ui/compare-slider";
import {
  Cropper,
  CropperArea,
  CropperImage,
} from "@thilke/ui/components/ui/cropper";
import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from "@thilke/ui/components/ui/drawer";
import {
  Editable,
  EditableArea,
  EditableInput,
  EditablePreview,
  EditableTrigger,
} from "@thilke/ui/components/ui/editable";
import {
  FileUpload,
  FileUploadDropzone,
  FileUploadTrigger,
} from "@thilke/ui/components/ui/file-upload";
import { Fps } from "@thilke/ui/components/ui/fps";
import { GaugeCombined } from "@thilke/ui/components/ui/gauge";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@thilke/ui/components/ui/hover-card";
import {
  Kanban,
  KanbanBoard,
  KanbanColumn,
  KanbanItem,
} from "@thilke/ui/components/ui/kanban";
import {
  KeyValue,
  KeyValueAdd,
  KeyValueItem,
  KeyValueKeyInput,
  KeyValueList,
  KeyValueValueInput,
} from "@thilke/ui/components/ui/key-value";
import {
  Listbox,
  ListboxGroup,
  ListboxGroupLabel,
  ListboxItem,
  ListboxItemIndicator,
} from "@thilke/ui/components/ui/listbox";
import { Marquee } from "@thilke/ui/components/ui/marquee";
import { MaskInput } from "@thilke/ui/components/ui/mask-input";
import {
  MediaPlayer,
  MediaPlayerControls,
  MediaPlayerPlay,
  MediaPlayerTime,
  MediaPlayerVideo,
} from "@thilke/ui/components/ui/media-player";
import {
  Mention,
  MentionContent,
  MentionInput,
  MentionItem,
  MentionLabel,
} from "@thilke/ui/components/ui/mention";
import {
  PhoneInput,
  PhoneInputCountrySelect,
  PhoneInputField,
} from "@thilke/ui/components/ui/phone-input";
import { QRCode, QRCodeSvg } from "@thilke/ui/components/ui/qr-code";
import { Rating, RatingItem } from "@thilke/ui/components/ui/rating";
import { RelativeTimeCard } from "@thilke/ui/components/ui/relative-time-card";
import {
  ResponsiveDialog,
  ResponsiveDialogContent,
  ResponsiveDialogHeader,
  ResponsiveDialogTitle,
  ResponsiveDialogTrigger,
} from "@thilke/ui/components/ui/responsive-dialog";
import {
  ScrollSpy,
  ScrollSpyLink,
  ScrollSpyNav,
  ScrollSpySection,
  ScrollSpyViewport,
} from "@thilke/ui/components/ui/scroll-spy";
import { Scroller } from "@thilke/ui/components/ui/scroller";
import {
  SegmentedInput,
  SegmentedInputItem,
} from "@thilke/ui/components/ui/segmented-input";
import {
  SelectionToolbar,
  SelectionToolbarItem,
} from "@thilke/ui/components/ui/selection-toolbar";
import {
  Sortable,
  SortableContent,
  SortableItem,
} from "@thilke/ui/components/ui/sortable";
import {
  SpeedDial,
  SpeedDialAction,
  SpeedDialContent,
  SpeedDialItem,
  SpeedDialLabel,
  SpeedDialTrigger,
} from "@thilke/ui/components/ui/speed-dial";
import { Stack } from "@thilke/ui/components/ui/stack";
import {
  Stat,
  StatDescription,
  StatIndicator,
  StatLabel,
  StatValue,
} from "@thilke/ui/components/ui/stat";
import {
  Status,
  StatusIndicator,
  StatusLabel,
} from "@thilke/ui/components/ui/status";
import {
  Stepper,
  StepperContent,
  StepperDescription,
  StepperIndicator,
  StepperItem,
  StepperList,
  StepperSeparator,
  StepperTitle,
  StepperTrigger,
} from "@thilke/ui/components/ui/stepper";
import { Swap, SwapOff, SwapOn } from "@thilke/ui/components/ui/swap";
import {
  TagsInput,
  TagsInputInput,
  TagsInputItem,
  TagsInputLabel,
  TagsInputList,
} from "@thilke/ui/components/ui/tags-input";
import { Textarea } from "@thilke/ui/components/ui/textarea";
import {
  TimePicker,
  TimePickerInput,
  TimePickerInputGroup,
  TimePickerLabel,
  TimePickerSeparator,
  TimePickerTrigger,
} from "@thilke/ui/components/ui/time-picker";
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDescription,
  TimelineDot,
  TimelineHeader,
  TimelineItem,
  TimelineTime,
  TimelineTitle,
} from "@thilke/ui/components/ui/timeline";
import {
  Tour,
  TourDescription,
  TourHeader,
  TourStep,
  TourTitle,
} from "@thilke/ui/components/ui/tour";
import { VisuallyHiddenInput } from "@thilke/ui/components/visually-hidden-input";
import {
  AlertCircle,
  Archive,
  Check,
  MoreHorizontal,
  Plus,
  Star,
} from "lucide-react";

const panel =
  "rounded-md border border-border bg-card p-3 text-card-foreground";
const mini = "text-xs text-muted-foreground";

export function ActionBarDemo() {
  return (
    <ActionBar className="rounded-md border bg-background p-1.5">
      <ActionBarSelection>3 selected</ActionBarSelection>
      <ActionBarSeparator />
      <ActionBarGroup>
        <ActionBarItem>Archive</ActionBarItem>
        <ActionBarItem>Tag</ActionBarItem>
      </ActionBarGroup>
    </ActionBar>
  );
}

export function AngleSliderDemo() {
  return (
    <AngleSlider defaultValue={[45]} size={112} className="mx-auto">
      <AngleSliderTrack />
      <AngleSliderRange />
      <AngleSliderThumb />
      <AngleSliderValue />
    </AngleSlider>
  );
}

export function AvatarGroupDemo() {
  return (
    <AvatarGroup max={3}>
      {["EV", "GB", "LN", "NL"].map((label) => (
        <div
          key={label}
          className="flex size-full items-center justify-center rounded-full border bg-muted text-xs font-medium"
        >
          {label}
        </div>
      ))}
    </AvatarGroup>
  );
}

export function BadgeOverflowDemo() {
  const tags = ["mech", "thermal", "license", "npc", "mission", "scene"];
  return (
    <BadgeOverflow
      items={tags}
      lineCount={1}
      className="flex max-w-sm flex-wrap gap-1.5"
      renderBadge={(tag) => <Badge variant="secondary">{tag}</Badge>}
      renderOverflow={(count) => <Badge variant="outline">+{count}</Badge>}
    />
  );
}

export function BannerDemo() {
  return (
    <Banner className="relative" defaultOpen>
      <BannerIcon>
        <AlertCircle className="size-4" />
      </BannerIcon>
      <BannerContent>
        <BannerTitle>Downtime window</BannerTitle>
        <BannerDescription>
          Foundry package sync is ready to review.
        </BannerDescription>
      </BannerContent>
    </Banner>
  );
}

export function CheckboxGroupDemo() {
  return (
    <CheckboxGroup defaultValue={["rules"]}>
      <CheckboxGroupLabel>Sync targets</CheckboxGroupLabel>
      <CheckboxGroupList>
        <CheckboxGroupItem value="rules">Rules</CheckboxGroupItem>
        <CheckboxGroupItem value="actors">Actors</CheckboxGroupItem>
      </CheckboxGroupList>
      <CheckboxGroupDescription>
        Select the compendium slices to publish.
      </CheckboxGroupDescription>
    </CheckboxGroup>
  );
}

export function CircularProgressDemo() {
  return <CircularProgressCombined value={68} className="size-28" />;
}

export function ColorPickerDemo() {
  return (
    <ColorPicker defaultValue="#ff5a1f">
      <ColorPickerTrigger>Molten Orange</ColorPickerTrigger>
    </ColorPicker>
  );
}

export function ColorSwatchDemo() {
  return <ColorSwatch color="#ff5a1f" className="size-12 rounded-md border" />;
}

export function ComboboxDemo() {
  return (
    <Combobox defaultValue="thermal-rifle">
      <ComboboxAnchor>
        <ComboboxInput placeholder="Search item" />
        <ComboboxTrigger />
      </ComboboxAnchor>
      <ComboboxContent>
        <ComboboxItem value="thermal-rifle">Thermal Rifle</ComboboxItem>
        <ComboboxItem value="hull-repair">Hull Repair</ComboboxItem>
      </ComboboxContent>
    </Combobox>
  );
}

export function CompareSliderDemo() {
  return (
    <CompareSlider className="h-32 overflow-hidden rounded-md border">
      <CompareSliderBefore className="flex items-center justify-center bg-muted text-sm">
        Before
      </CompareSliderBefore>
      <CompareSliderAfter className="flex items-center justify-center bg-primary/20 text-sm">
        After
      </CompareSliderAfter>
      <CompareSliderHandle />
    </CompareSlider>
  );
}

export function CropperDemo() {
  return (
    <Cropper
      className="h-36 overflow-hidden rounded-md border"
      crop={{ x: 20, y: 20 }}
    >
      <CropperImage
        src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='320' height='180'%3E%3Crect width='320' height='180' fill='%232d2d2d'/%3E%3Ccircle cx='160' cy='90' r='50' fill='%23ff5a1f'/%3E%3C/svg%3E"
        alt="abstract token"
      />
      <CropperArea />
    </Cropper>
  );
}

export function DrawerDemo() {
  return (
    <Drawer>
      <DrawerTrigger asChild>
        <Button variant="outline">Open drawer</Button>
      </DrawerTrigger>
      <DrawerContent>
        <DrawerHeader>
          <DrawerTitle>Drawer preview</DrawerTitle>
        </DrawerHeader>
      </DrawerContent>
    </Drawer>
  );
}

export function EditableDemo() {
  return (
    <Editable defaultValue="Mission Brief">
      <EditableArea>
        <EditablePreview className="rounded-md border px-3 py-2" />
        <EditableInput />
      </EditableArea>
      <EditableTrigger asChild>
        <Button variant="ghost" size="sm">
          Edit
        </Button>
      </EditableTrigger>
    </Editable>
  );
}

export function FileUploadDemo() {
  return (
    <FileUpload maxFiles={2}>
      <FileUploadDropzone className="rounded-md border border-dashed p-4 text-center">
        <p className={mini}>Drop handouts here</p>
        <FileUploadTrigger asChild>
          <Button size="sm" variant="outline">
            Choose file
          </Button>
        </FileUploadTrigger>
      </FileUploadDropzone>
    </FileUpload>
  );
}

export function FpsDemo() {
  return <Fps className={panel} />;
}
export function GaugeDemo() {
  return <GaugeCombined value={72} className="w-36" />;
}

export function HoverCardDemo() {
  return (
    <HoverCard>
      <HoverCardTrigger asChild>
        <Button variant="outline">Hover card</Button>
      </HoverCardTrigger>
      <HoverCardContent>
        Operational details for this registry primitive.
      </HoverCardContent>
    </HoverCard>
  );
}

export function KanbanDemo() {
  const value = { todo: ["Brief"], doing: ["Scene"] };
  return (
    <Kanban value={value}>
      <KanbanBoard className="grid grid-cols-2 gap-2">
        {Object.entries(value).map(([column, items]) => (
          <KanbanColumn
            key={column}
            value={column}
            className="rounded-md border bg-muted/40 p-2"
          >
            <div className="mb-2 text-xs font-medium uppercase">{column}</div>
            <div className="grid gap-1.5">
              {items.map((item) => (
                <KanbanItem
                  key={item}
                  value={item}
                  className="rounded-md border bg-card p-2 text-sm"
                >
                  {item}
                </KanbanItem>
              ))}
            </div>
          </KanbanColumn>
        ))}
      </KanbanBoard>
    </Kanban>
  );
}

export function KeyValueDemo() {
  return (
    <KeyValue
      defaultValue={[
        { id: "range", key: "range", value: "10" },
        { id: "damage", key: "damage", value: "1d6" },
      ]}
      className="max-w-sm"
    >
      <KeyValueList>
        <KeyValueItem>
          <KeyValueKeyInput />
          <KeyValueValueInput />
        </KeyValueItem>
      </KeyValueList>
      <KeyValueAdd asChild>
        <Button variant="outline" size="sm">
          Add key
        </Button>
      </KeyValueAdd>
    </KeyValue>
  );
}

export function ListboxDemo() {
  return (
    <Listbox defaultValue="everest" className="max-w-sm">
      <ListboxGroup>
        <ListboxGroupLabel>Frames</ListboxGroupLabel>
        <ListboxItem value="everest">
          Everest <ListboxItemIndicator />
        </ListboxItem>
        <ListboxItem value="goblin">
          Goblin <ListboxItemIndicator />
        </ListboxItem>
      </ListboxGroup>
    </Listbox>
  );
}

export function MarqueeDemo() {
  return (
    <Marquee className="max-w-sm rounded-md border py-2">
      <span className="mx-4 text-sm">Lancer • Foundry • Thilke UI •</span>
    </Marquee>
  );
}

export function MaskInputDemo() {
  return <MaskInput mask="ssn" placeholder="123-456" />;
}

export function MediaPlayerDemo() {
  return (
    <MediaPlayer
      className="overflow-hidden rounded-md border"
      label="Preview video"
      withoutTooltip
    >
      <MediaPlayerVideo src="" className="aspect-video bg-muted" />
      <MediaPlayerControls className="flex items-center gap-2 p-2">
        <MediaPlayerPlay size="sm" />
        <MediaPlayerTime />
      </MediaPlayerControls>
    </MediaPlayer>
  );
}

export function MentionDemo() {
  return (
    <Mention>
      <MentionLabel>Message</MentionLabel>
      <MentionInput placeholder="Mention @Everest" />
      <MentionContent>
        <MentionItem value="everest">Everest</MentionItem>
        <MentionItem value="goblin">Goblin</MentionItem>
      </MentionContent>
    </Mention>
  );
}

export function PhoneInputDemo() {
  return (
    <PhoneInput defaultValue="+15551234567">
      <PhoneInputCountrySelect />
      <PhoneInputField />
    </PhoneInput>
  );
}

export function QrCodeDemo() {
  return (
    <QRCode value="https://ui.thilke.com" size={112}>
      <QRCodeSvg />
    </QRCode>
  );
}

export function RatingDemo() {
  return (
    <Rating defaultValue={3} max={5}>
      {[0, 1, 2, 3, 4].map((i) => (
        <RatingItem key={`rating-${i}`} index={i}>
          <Star className="size-5" />
        </RatingItem>
      ))}
    </Rating>
  );
}

export function RelativeTimeCardDemo() {
  return (
    <RelativeTimeCard date={Date.now() - 3600_000}>Last sync</RelativeTimeCard>
  );
}

export function ResponsiveDialogDemo() {
  return (
    <ResponsiveDialog>
      <ResponsiveDialogTrigger asChild>
        <Button variant="outline">Responsive dialog</Button>
      </ResponsiveDialogTrigger>
      <ResponsiveDialogContent>
        <ResponsiveDialogHeader>
          <ResponsiveDialogTitle>Responsive surface</ResponsiveDialogTitle>
        </ResponsiveDialogHeader>
      </ResponsiveDialogContent>
    </ResponsiveDialog>
  );
}

export function ScrollSpyDemo() {
  return (
    <ScrollSpy className="grid grid-cols-[120px_1fr] gap-3">
      <ScrollSpyNav>
        <ScrollSpyLink value="one">One</ScrollSpyLink>
        <ScrollSpyLink value="two">Two</ScrollSpyLink>
      </ScrollSpyNav>
      <ScrollSpyViewport className="h-28 overflow-auto rounded-md border p-3">
        <ScrollSpySection value="one" className="h-24">
          <h4 className="font-medium">One</h4>
        </ScrollSpySection>
        <ScrollSpySection value="two" className="h-24">
          <h4 className="font-medium">Two</h4>
        </ScrollSpySection>
      </ScrollSpyViewport>
    </ScrollSpy>
  );
}

export function ScrollerDemo() {
  return (
    <Scroller className="h-24 max-w-sm overflow-auto rounded-md border p-3">
      <div className="h-40 text-sm">
        Scrollable operational notes
        <br />
        Scene A<br />
        Scene B<br />
        Scene C
      </div>
    </Scroller>
  );
}

export function SegmentedInputDemo() {
  return (
    <SegmentedInput>
      <SegmentedInputItem placeholder="AA" maxLength={2} />
      <SegmentedInputItem placeholder="BB" maxLength={2} />
      <SegmentedInputItem placeholder="CC" maxLength={2} />
    </SegmentedInput>
  );
}

export function SelectionToolbarDemo() {
  return (
    <SelectionToolbar open>
      <p className="rounded-md border p-3 text-sm">
        Select text to invoke actions.
      </p>
      <SelectionToolbarItem size="sm">Copy</SelectionToolbarItem>
      <SelectionToolbarItem size="sm">Link</SelectionToolbarItem>
    </SelectionToolbar>
  );
}

export function SortableDemo() {
  const items = ["Rules", "Actors", "Items"];
  return (
    <Sortable value={items}>
      <SortableContent className="grid gap-1.5">
        {items.map((item) => (
          <SortableItem
            key={item}
            value={item}
            className="rounded-md border bg-card p-2 text-sm"
          >
            {item}
          </SortableItem>
        ))}
      </SortableContent>
    </Sortable>
  );
}

export function SpeedDialDemo() {
  return (
    <SpeedDial defaultOpen>
      <SpeedDialTrigger asChild>
        <Button size="icon">
          <Plus className="size-4" />
        </Button>
      </SpeedDialTrigger>
      <SpeedDialContent>
        <SpeedDialItem>
          <SpeedDialAction>
            <Archive className="size-4" />
          </SpeedDialAction>
          <SpeedDialLabel>Archive</SpeedDialLabel>
        </SpeedDialItem>
        <SpeedDialItem>
          <SpeedDialAction>
            <MoreHorizontal className="size-4" />
          </SpeedDialAction>
          <SpeedDialLabel>More</SpeedDialLabel>
        </SpeedDialItem>
      </SpeedDialContent>
    </SpeedDial>
  );
}

export function StackDemo() {
  return (
    <Stack className="max-w-sm">
      {["Actor", "Item", "Scene"].map((x) => (
        <div key={x} className="rounded-md border bg-card p-3 text-sm">
          {x}
        </div>
      ))}
    </Stack>
  );
}

export function StatDemo() {
  return (
    <Stat className="max-w-xs">
      <StatLabel>Heat</StatLabel>
      <StatValue>3/8</StatValue>
      <StatIndicator variant="badge" color="warning">
        warm
      </StatIndicator>
      <StatDescription>Tracked via Dice Stat anatomy.</StatDescription>
    </Stat>
  );
}

export function StatusDemo() {
  return (
    <Status variant="success">
      <StatusIndicator />
      <StatusLabel>online</StatusLabel>
    </Status>
  );
}

export function StepperDemo() {
  return (
    <Stepper defaultValue="brief">
      <StepperList>
        <StepperItem value="brief">
          <StepperTrigger>
            <StepperIndicator />
            <StepperTitle>Brief</StepperTitle>
            <StepperDescription>Ready</StepperDescription>
          </StepperTrigger>
          <StepperSeparator />
        </StepperItem>
        <StepperItem value="deploy">
          <StepperTrigger>
            <StepperIndicator />
            <StepperTitle>Deploy</StepperTitle>
          </StepperTrigger>
        </StepperItem>
      </StepperList>
      <StepperContent value="brief" className="mt-3 text-sm">
        Mission briefing complete.
      </StepperContent>
    </Stepper>
  );
}

export function SwapDemo() {
  return (
    <Swap className="relative inline-grid rounded-md border p-3">
      <SwapOn>
        <Check className="size-5" />
      </SwapOn>
      <SwapOff>
        <Plus className="size-5" />
      </SwapOff>
    </Swap>
  );
}

export function TagsInputDemo() {
  return (
    <TagsInput defaultValue={["lancer", "rules"]}>
      <TagsInputLabel>Tags</TagsInputLabel>
      <TagsInputList>
        <TagsInputItem value="lancer">lancer</TagsInputItem>
        <TagsInputItem value="rules">rules</TagsInputItem>
        <TagsInputInput placeholder="Add tag" />
      </TagsInputList>
    </TagsInput>
  );
}

export function TextareaDemo() {
  return (
    <Textarea
      placeholder="Scene notes"
      defaultValue="Hold the gate until extraction."
    />
  );
}

export function TimePickerDemo() {
  return (
    <TimePicker defaultValue="18:30">
      <TimePickerLabel>Session time</TimePickerLabel>
      <TimePickerInputGroup>
        <TimePickerInput segment="hour" />
        <TimePickerSeparator />
        <TimePickerInput segment="minute" />
      </TimePickerInputGroup>
      <TimePickerTrigger asChild>
        <Button variant="outline" size="sm">
          Pick
        </Button>
      </TimePickerTrigger>
    </TimePicker>
  );
}

export function TimelineDemo() {
  return (
    <Timeline activeIndex={1} className="w-full max-w-sm">
      {["Brief", "Encounter", "Extract"].map((x, i) => (
        <TimelineItem key={x}>
          <TimelineDot />
          <TimelineContent>
            <TimelineHeader>
              <TimelineTitle>{x}</TimelineTitle>
              <TimelineTime>{`T+${i}`}</TimelineTime>
            </TimelineHeader>
            <TimelineDescription>Mission phase {i + 1}</TimelineDescription>
          </TimelineContent>
          <TimelineConnector />
        </TimelineItem>
      ))}
    </Timeline>
  );
}

export function TourDemo() {
  return (
    <Tour open={false}>
      <div id="tour-target" className={panel}>
        Tour target
      </div>
      <TourStep target="#tour-target">
        <TourHeader>
          <TourTitle>Tour</TourTitle>
          <TourDescription>Guided flow shell.</TourDescription>
        </TourHeader>
      </TourStep>
    </Tour>
  );
}

export function VisuallyHiddenInputDemo() {
  return (
    <div className="flex items-center gap-2 text-sm">
      <span className="rounded-md border px-3 py-2">Hidden native input</span>
      <VisuallyHiddenInput control={null} value="registry" />
    </div>
  );
}
